/**
 * @file 本だなの平積み (最近さわった本を横に並べる)。
 *
 * @what: model/recentShelf.ts が選んだ資料を、大きめの表紙と題名で横一列に並べる。
 *   横にスワイプして見る (scroll-snap)。表紙を押すとリーダーへ行き、リーダーが前回開いていた
 *   ページから始める (useResumePage)。1冊も無ければ何も出さない。
 * @why: 本だなの上に、平積みのように「いま読んでいる本」を置き、役割のセクションから
 *   探さずに開けるようにする (代表の要望、2026-09-08)。題名を付けるのは、書影が引けない
 *   本は頭文字の枠になり、表紙だけでは見分けられないためである。
 * @failure: 描画のみ。
 */

import { Link } from "react-router-dom";
import type { StudySource } from "../api/sources";
import { SourceCover } from "./SourceCover";
import "./study.css";

export function RecentShelf({
  familyId,
  sources,
  sourcesById,
}: {
  familyId: string;
  /** 並べる資料 (先頭が最も新しい。model/recentShelf.ts が選んだもの)。 */
  sources: readonly StudySource[];
  /** 本だなの全資料を id で引く表である。別冊の表紙に本体 (問題編) の表紙を使うために引く。 */
  sourcesById: ReadonlyMap<string, StudySource>;
}) {
  if (sources.length === 0) return null;
  return (
    <section className="study-recent-shelf" aria-label="さいきんの本">
      <h3 className="study-shelf-section-title">さいきんの本</h3>
      <ul className="study-recent-shelf-row">
        {sources.map((s) => {
          const parent = s.companion_of ? sourcesById.get(s.companion_of) : undefined;
          const href = `/study/${encodeURIComponent(familyId)}/sources/${encodeURIComponent(s.id)}`;
          return (
            <li key={s.id} className="study-recent-item">
              <Link className="study-recent-link" to={href} aria-label={`${s.title} を開く`}>
                <SourceCover
                  familyId={familyId}
                  source={s}
                  {...(parent ? { parent } : {})}
                  className="study-recent-cover"
                />
                <span className="study-recent-title" aria-hidden="true">
                  {s.title}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
